module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige2-69784c3d3539397e57d3eced743279ea.jpg";